// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app__modules_study_study_module_ts":"e5e67e809db7a0d5","src_app__modules_dashboard_dashboard_module_ts":"6155236e59e0cb56"}[chunkId] + ".js";
};